import Flickity from "flickity";

class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-carousel]');
        self.icon = self.elem.querySelector('[data-icon]');
    }

    init() {
        let self = this;

        self.getCarousel();
    }

    getCarousel() {
        let self = this;

        let rotateValue = 90;

        const flkty = new Flickity(self.carouselElem, {
            adaptiveHeight: true,
            autoPlay: false,
            draggable: true,
            prevNextButtons: false,
            wrapAround: true
        });

        flkty.on('change', function() {
            self.icon.style.transform = 'rotate('+rotateValue+'deg)';
            rotateValue = rotateValue+90;
        });
    }
}

export default Carousel;
